"use client";

import Link from "next/link";
import { useCheckoutCart } from "./useCheckoutCart";

export function AddToCartButton({
  moduleId,
  label = "Add to cart",
}: {
  moduleId: string;
  label?: string;
}) {
  const { addModule, cart } = useCheckoutCart();
  const inCart = cart.moduleIds.includes(moduleId);

  if (inCart) {
    return (
      <Link href="/checkout" className="btn btn-primary">
        In cart · Checkout
      </Link>
    );
  }

  return (
    <button
      type="button"
      className="btn btn-ghost"
      onClick={() => addModule(moduleId)}
    >
      {label}
    </button>
  );
}

export function CartLink() {
  const { itemCount, ready } = useCheckoutCart();
  if (!ready) return null;
  return (
    <Link href="/checkout" className="checkout-cart-link">
      Cart{itemCount > 0 ? ` (${itemCount})` : ""}
    </Link>
  );
}
